import { render, staticRenderFns } from "./CommerceAddNew.vue?vue&type=template&id=34b78f7e"
import script from "./CommerceAddNew.vue?vue&type=script&lang=js"
export * from "./CommerceAddNew.vue?vue&type=script&lang=js"
import style0 from "./CommerceAddNew.vue?vue&type=style&index=0&id=34b78f7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports